import { Form } from '@domain-group/suit-theme'

import type { DataStoreItemData, DataStoreItemSection } from '@functions/groupDataStoreItems'

import DataStoreItem from './DataStoreItem'

interface DataStoreGroupSectionProps {
  index: number,
  section: DataStoreItemSection,
}

const DataStoreGroupSection = (props: DataStoreGroupSectionProps) => {
  const {
    index,
    section: { key, isGroupedResponse, items },
  } = props

  return (
    <>
      <Form.Field
        boxProps={{ padding: 'large', paddingBottom: 'small' }}
        labelProps={{
          color: 'bodyFontColor', textAlign: 'center', fontWeight: 600, marginY: 'auto', letterSpacing: 0,
        }}
        // @ts-expect-error TS2322
        label={isGroupedResponse ? `Response #${index + 1}` : key}
      />

      {/*
       // @ts-expect-error TS2339 */}
      {items.map((
        groupedItem: { key: string, data: DataStoreItemData },
        i: number,
      ) => (
        <DataStoreItem
          dataStoreItem={groupedItem.data}
          // @ts-expect-error TS2339
          isLastItem={items.length - 1 === i}
          key={groupedItem.key}
        />
      ))}
    </>
  )
}

export default DataStoreGroupSection
